import dayjs from 'dayjs'

function getMaxDate() {
  const year = new Date().getFullYear()
  return dayjs(`${year}-12-31`)
}

export default getMaxDate
